import { make } from 'vuex-pathify'
import Comment from '@/api/comment'

const state = {
  comments: []
}

const getters = {
  ...make.getters(state)
}

const mutations = {
  ...make.mutations(state),
  PUSH_COMMENTS: (state, payload) => {
    state.comments.push(payload)
  }
}

const actions = {
  async getComments({ commit }, payload) {
    commit('SET_COMMENTS', [])
    const response = await Comment.getComments(payload)
    commit('SET_COMMENTS', response.data.comments)
    return response
  },

  async createComment({ commit, dispatch }, payload) {
    try {
      const response = await Comment.create(payload)
      commit('PUSH_COMMENTS', response.data.comment)
      const { message } = response
      dispatch('notify/show', message, { root: true })
      return response
    } catch (e) {
      console.log(e)
      return false
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
